export enum MetricResolution {
    Min10 = 'min10',
    Daily = 'daily',
    Monthly = 'monthly'
}
